import { createRequest, prune } from "../../utils/utility";
import { ID } from "../types";
import { ValidationMessages } from "../../utils/types";
import { validateRequiredNotDefault } from "../../utils/validation";

export class Payment {
  id: ID = Payment.default().id;
  bank: string = Payment.default().bank;
  IBAN: string = Payment.default().IBAN;
  name: string = Payment.default().name;
  BIC: string = Payment.default().BIC;

  constructor(obj: any) {
    obj && Object.assign(this, prune(obj));
  }

  static readonly addFields : Array<string> = [
    "bank",
    "IBAN",
    "name",
    "BIC"
  ];

  static readonly removeFields : Array<string> = [
    "id"
  ];

  static readonly updateFields : Array<string> = [
    "bank",
    "IBAN",
    "name",
    "BIC"
  ];

  static required(): any {
    return {
      id: false,
      bank: true,
      IBAN: true,
      name: false,
      BIC: false,
    };
  }

  static default(): any {
    return {
      id: null,
      bank: "",
      IBAN: "",
      name: "",
      BIC: "",
    };
  }

  validate(keys: Array<string>, messages: any): any {
    return validateRequiredNotDefault(
      {},
      Payment.required(),
      this,
      Payment.default(),
      keys,
      messages[ValidationMessages.Required]
    );
  }

  private createRequest(fields: Array<string>): any {
    return createRequest(this, fields);
  }

  addRequest(makeDefault: boolean): any {
    let data = this.createRequest(Payment.addFields);

    data.makeDefault = makeDefault;

    return data;
  }

  removeRequest(): any {
    return this.createRequest(Payment.removeFields);
  }

  updateRequest(): any {
    return this.createRequest(Payment.updateFields);
  }
}
